import { render, staticRenderFns } from "./AttentionMessage.vue?vue&type=template&id=4350d8cc&scoped=true&"
import script from "./AttentionMessage.vue?vue&type=script&lang=js&"
export * from "./AttentionMessage.vue?vue&type=script&lang=js&"
import style0 from "./AttentionMessage.vue?vue&type=style&index=0&id=4350d8cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350d8cc",
  null
  
)

export default component.exports